import { render } from "./PlayersLounge.vue?vue&type=template&id=631d7da6&scoped=true"
import script from "./PlayersLounge.vue?vue&type=script&lang=js"
export * from "./PlayersLounge.vue?vue&type=script&lang=js"

import "./PlayersLounge.vue?vue&type=style&index=0&id=631d7da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631d7da6"]])

export default __exports__